import { GoogleGenAI, Type, FunctionDeclaration } from "@google/genai";
import { NodeDevice } from "../types";

const getAI = () => new GoogleGenAI({ apiKey: process.env.API_KEY });

const createCameraTool: FunctionDeclaration = {
    name: "create_camera",
    description: "Crea una o más cámaras nuevas en la base de datos.",
    parameters: {
        type: Type.OBJECT,
        properties: {
            cameras: {
                type: Type.ARRAY,
                items: {
                    type: Type.OBJECT,
                    properties: {
                        name: { type: Type.STRING, description: "Nombre (ej: MC75-01)" },
                        ip: { type: Type.STRING, description: "IP o Host" },
                        channel: { type: Type.NUMBER, description: "Canal" },
                        port: { type: Type.NUMBER, description: "Puerto" },
                        brand: { type: Type.STRING, description: "Marca" },
                        type: { type: Type.STRING, description: "TIPO (GRABADOR/INDIVIDUAL)" },
                        status: { type: Type.STRING, description: "Estado (ONLINE/OFFLINE/Null)" }
                    },
                    required: ["name", "ip", "channel", "port", "brand", "type"]
                }
            }
        },
        required: ["cameras"]
    }
};

const updateCameraTool: FunctionDeclaration = {
    name: "update_camera",
    description: "Actualiza una cámara existente usando su ID numérico.",
    parameters: {
        type: Type.OBJECT,
        properties: {
            id: { type: Type.STRING, description: "ID numérico de la cámara según la lista proporcionada." },
            updates: {
                type: Type.OBJECT,
                properties: {
                    name: { type: Type.STRING },
                    ip: { type: Type.STRING },
                    status: { type: Type.STRING }
                }
            }
        },
        required: ["id", "updates"]
    }
};

const deleteCameraTool: FunctionDeclaration = {
    name: "delete_camera",
    description: "Elimina una cámara del sistema usando su ID numérico real.",
    parameters: {
        type: Type.OBJECT,
        properties: {
            id: { type: Type.STRING, description: "El ID numérico exacto de la cámara a eliminar." }
        },
        required: ["id"]
    }
};

export const sendChatMessage = async (
    message: string, 
    history: any[] = [],
    currentNodes: NodeDevice[] = []
) => {
    const ai = getAI();
    const model = "gemini-3-pro-preview";
    
    // Construimos un resumen de los nodos para que Gemini sepa los IDs reales
    const nodesSummary = currentNodes.length > 0 
        ? `LISTA ACTUAL DE CÁMARAS (Contexto para IDs):
${currentNodes.map(n => `- ${n.name} (IP: ${n.ip}) -> ID: ${n.id}`).join('\n')}`
        : "La base de datos está actualmente vacía.";

    try {
        const response = await ai.models.generateContent({
            model: model,
            contents: [...history, { role: "user", parts: [{ text: message }] }],
            config: {
                systemInstruction: `Eres el Operador de Red de Axend. Gestionas una base de datos de cámaras.
                
                REGLA DE ORO PARA ELIMINACIÓN Y ACTUALIZACIÓN:
                Cuando el usuario mencione un nombre de cámara (ej: "Borra MC-TEST-01"), DEBES buscar su ID numérico en la lista de contexto que te proporciono abajo y usar ESE ID en la herramienta.
                NUNCA envíes el nombre como ID si existe un ID numérico disponible.
                
                ${nodesSummary}

                REGLA PARA RANGOS: 
                Si piden crear rangos (ej: MC75 puertos 8001-8010), crea objetos individuales con nombres incrementales.
                
                Responde siempre en español, técnico y breve.`,
                tools: [{ functionDeclarations: [createCameraTool, updateCameraTool, deleteCameraTool] }]
            }
        });

        return {
            text: response.text,
            functionCalls: response.functionCalls
        };
    } catch (error) {
        console.error("AI Error:", error);
        return { text: "Error de conexión con el núcleo IA.", functionCalls: [] };
    }
};